<template>
    <el-dialog :visible.sync="dialogVisible" class="salOrderMeetDialog" v-if="dialogVisible" v-dragable :close-on-click-modal="false" @close="dialogClose" width="800px">
        <el-container>
            <el-aside width="500px">
                <el-card class="dialog_box_card" shadow="never">
                    <template slot="header">
                        <div><span class="font_size_14">客户余额</span></div>
                        <div><span>欠款:</span><span class="text font_size_14">{{ arrearAmt }}</span></div>
                        <div><span>预收款:</span><span class="text font_size_14">{{ prePayAmt }}</span></div>
                        <div></div>
                        <div v-if="power.splitPayAndReturnPrePay == 'Y'">
                            <span>收款:</span><span class="text font_size_14">{{ payPrepayAmt }}</span>
                            <span>退货:</span><span class="text font_size_14">{{ returnPrepayAmt }}</span>
                        </div>
                    </template>
                    <div>
                        <div class="el-form el-form--inline" style="display: flex; justify-content: space-around;">
                            <div class="el-form-item mar_b_10">
                                <label class="el-form-item__label">总金额:</label>
                                <div class="el-form-item__content">
                                    <span class="text font_size_14">{{ totalAmt }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="el-form el-form--inline" style="display: flex; justify-content: space-around;">
                            <div class="el-form-item mar_b_10" style="width: 100%; display: flex; align-items: center; justify-content: space-between;">
                                <div class="el-form-item__content">
                                    <el-radio-group v-model="queryForm.payType" @change="payTypeChange">
                                        <el-radio v-for="item in payTypeList" :key="item.value" :label="item">{{ item.text }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>
                        <div class="el-form el-form--inline prePay_from" style="display: flex; justify-content: space-around; flex-wrap: wrap;">
                            <div class="el-form-item mar_b_10">
                                <label class="el-form-item__label">折扣:</label>
                                <div class="el-form-item__content">
                                    <el-input-number class="input_number" controls-position="right" v-model.number="queryForm.discountAmt" :precision="2" :min="0" :max="Number(totalAmt)" @focus="focusAfterSelect($event)" @change="inputNumberChange($event, 'discountAmt')"></el-input-number>
                                </div>
                            </div>
                            <div class="el-form-item mar_b_10" style="position: relative;" v-if="power.brandArrear == 'N'">
                                <div v-if="power.splitPayAndReturnPrePay == 'N'">
                                    <label class="el-form-item__label">冲抵预收:</label>
                                    <div class="el-form-item__content">
                                        <el-input-number class="input_number" controls-position="right" v-model.number="queryForm.prePayAmt" :precision="2" :min="0" :max="Number(totalAmt)" @focus="focusAfterSelect($event)" @change="inputNumberChange($event, 'prePayAmt')"></el-input-number>
                                    </div>
                                </div>
                                <div v-else>
                                    <label class="el-form-item__label prePay_from_item__label">冲抵预收</label>
                                    <div class="el-input el-input-group el-input-group--prepend">
                                        <div class="el-input-group__prepend">
                                            <el-select class="dialog_select" v-model="queryForm.splitPayAndReturnPrePay" placeholder="请选择" style="width: 80px;">
                                                <el-option label="收款预收" value="1"></el-option>
                                                <el-option label="退货预收" value="2"></el-option>
                                            </el-select>
                                        </div>
                                        <el-input-number class="input_number" controls-position="right" v-model.number="queryForm.prePayAmt" :precision="2" :min="0" :max="Number(totalAmt)" @focus="focusAfterSelect($event)" @change="inputNumberChange($event, 'prePayAmt')"></el-input-number>
                                    </div>
                                </div>
                            </div>
                            <div class="el-form-item">
                                <label class="el-form-item__label">实收:</label>
                                <div class="el-form-item__content">
                                    <el-input-number class="input_number" controls-position="right" v-model.number="queryForm.payableAmt" :precision="2" :min="0" :max="Number(totalAmt)" @focus="focusAfterSelect($event)" @change="inputNumberChange($event, 'payableAmt')"></el-input-number>
                                </div>
                            </div>
                            <div class="el-form-item" v-if="power.brandArrear == 'N'">
                                <label class="el-form-item__label">新增欠款:</label>
                                <div class="el-form-item__content">
                                    <el-input-number class="input_number" controls-position="right" v-model.number="queryForm.arrearAmt" :precision="2" :min="0" :max="Number(totalAmt)" @focus="focusAfterSelect($event)" @change="inputNumberChange($event, 'arrearAmt')"></el-input-number>
                                </div>
                            </div>
                            <div v-else style="width: 230px;"></div>
                        </div>
                        <div class="dialog_table" style="height: 260px;" v-if="power.brandArrear == 'Y'">
                            <el-table ref="dialogTable" v-loading="dialogTableLoading" :data="dialogTable" border stripe height="100%" max-height="100%" highlight-current-row @cell-click="tableCellClick" style="width: 100%">
                                <el-table-column label="品牌和欠款信息">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.financialBrandName }}</span>
                                        <span style="display: block; mrgin-top: -8px;">欠款:<span class="text">{{ scope.row.oldArrearAmt }}</span></span>
                                        <span style="display: block; mrgin-top: -8px;">预收:<span class="text">{{ scope.row.oldPrePayAmt }}</span></span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalAmt" label="应收金额" width="100"></el-table-column>
                                <el-table-column prop="arrearAmt" label="欠款金额" width="100">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.isShowArrearAmt && scope.row.financialBrandID != '2010010101010000000'">
                                            <el-input-number style="width: 100%; padding: 0;" :controls="false" size="mini" v-model="scope.row.arrearAmt" :precision="2" :max="scope.row.totalAmt" v-focus @blur="scope.row.isShowArrearAmt = false" @change="(val, oldVal) => { dialogTableInputNumberChange(val, oldVal, scope) }"></el-input-number>
                                        </div>
                                        <span v-else>{{ scope.row.arrearAmt }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prepayAmt" label="预收金额" width="100">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.isShowPrepayAmt && scope.row.oldPrePayAmt != 0">
                                            <el-input-number style="width: 100%; padding: 0;" :controls="false" size="mini" v-model="scope.row.prepayAmt" :precision="2" :max="scope.row.financialBrandID != '2010010101010000000' ? (Number(scope.row.oldPrePayAmt) < Number(scope.row.totalAmt) ? scope.row.oldPrePayAmt : scope.row.totalAmt) : Infinity" v-focus @blur="scope.row.isShowPrepayAmt = false" @change="(val, oldVal) => { dialogTableInputNumberChange(val, oldVal, scope) }"></el-input-number>
                                        </div>
                                        <span v-else>{{ scope.row.prepayAmt }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-card>
            </el-aside>
            <el-main class="main">
                <el-card class="dialog_box_card dialog_min_card" shadow="never" style="height: calc(100% - 2px);">
                    <div>
                        <el-form label-width="105px">
                            <el-form-item label="总金额:" class="mar_b_0">
                                <span class="text font_size_14">{{totalAmt}}</span>
                            </el-form-item>
                            <el-form-item label="折扣:" class="mar_b_0">
                                <span class="text font_size_14">{{queryForm.discountAmt}}</span>
                            </el-form-item>
                            <el-form-item label="冲抵预收:" class="mar_b_0">
                                <span class="text font_size_14">{{queryForm.prePayAmt}}</span>
                            </el-form-item>
                            <el-form-item label="实收:" class="mar_b_0">
                                <span class="text font_size_14">{{queryForm.payableAmt}}</span>
                            </el-form-item>
                            <el-form-item label="新增欠款:" class="mar_b_10">
                                <span class="text font_size_14">{{queryForm.arrearAmt}}</span>
                            </el-form-item>
                        </el-form>
                        <div v-if="power.isMoreCollection == 'Y'">
                            <div class="el-form el-form--inline" style="display: flex; justify-content: space-around;">
                                <div class="el-form-item">
                                    <label class="el-form-item__label">现金:</label>
                                    <div class="el-form-item__content">
                                        <el-input-number class="input_number" controls-position="right" v-model="queryForm.cashAmt" :precision="2" :min="0" :max="queryForm.payableAmt" @focus="focusAfterSelect($event)" @change="rightInputNumberChange($event, 'cashAmt')"></el-input-number>
                                    </div>
                                </div>
                            </div>
                            <div class="el-form el-form--inline prePay_from" style="display: flex; justify-content: space-around;">
                                <div class="el-form-item mar_b_10">
                                    <label class="el-form-item__label prePay_from_item__label">支付方式</label>
                                    <div class="el-form-item__content">
                                        <div class="el-input el-input-group el-input-group--prepend">
                                            <div :class="['el-input-group__prepend', { disable: queryForm.account.isDisabled }]">
                                                <select-multiple ref="account" class="dialog_select" style="width: 66px;" :select-data="queryForm.account" :isClear="false"></select-multiple>
                                            </div>
                                            <el-input-number class="input_number" controls-position="right" v-model="queryForm.cardAmt" :precision="2" :min="0" :max="queryForm.payableAmt" :disabled="queryForm.account.isDisabled" @focus="focusAfterSelect($event)" @change="rightInputNumberChange($event, 'cardAmt')"></el-input-number>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="el-form el-form--inline" style="display: flex; justify-content: space-around;">
                                <div class="el-form-item" style="margin-bottom: 10px;">
                                    <label class="el-form-item__label">支付方式:</label>
                                    <div class="el-form-item__content">
                                        <select-multiple ref="account" class="dialog_select" style="width: 100px;" :select-data="queryForm.account" :isClear="false"></select-multiple>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-form el-form--inline" style="display: flex; justify-content: space-around;">
                        <div class="el-form-item mar_b_10">
                            <label class="el-form-item__label"></label>
                            <div class="el-form-item__content">
                                <el-button type="primary" @click="onSubmit()">提交</el-button>
                                <!-- <el-button v-if="$root.btnPower.isRecordPrint == 'Y'" type="primary" @click="onSubmit('A')">提交并打印</el-button> -->
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-main>
        </el-container>
    </el-dialog>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        power: Object,
        dialogInfo: Object,
        customerPayType: String
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    e.currentTarget.select()
                }
                el.querySelector('input').focus()
            }
        },
        dragable: {
            bind: function (el) {
                //获取弹框头部（这部分可双击全屏）
                const dialogHeaderEl = el.querySelector('.salOrderMeetDialog .el-dialog__header');
                // const dialogHeaderEl = el.querySelector('.el-dialog');
                //弹窗
                const dragDom = el.querySelector('.el-dialog');
                //头部加上可拖动cursor
                dialogHeaderEl.style.cursor = 'move';

                // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
                const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
                let moveDown = (e) => {
                // 鼠标按下，计算当前元素距离可视区的距离
                const disX = e.clientX - dialogHeaderEl.offsetLeft;
                const disY = e.clientY - dialogHeaderEl.offsetTop;
                // const disX = e.clientX;
                // const disY = e.clientY;
                // 获取到的值带px 正则匹配替换
                let styL, styT;

                // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px

                if (sty.left.includes('%')) {
                    styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                    styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
                } else {
                    styL = +sty.left.replace(/\px/g, '');
                    styT = +sty.top.replace(/\px/g, '');
                };
                document.onmousemove = function (e) {
                    // 通过事件委托，计算移动的距离
                    const l = e.clientX - disX;
                    const t = e.clientY - disY;
                    // 移动当前元素
                    dragDom.style.left = (l + styL) + 'px';
                    dragDom.style.top = (t + styT) + 'px';
                    //将此时的位置传出去
                    //binding.value({x:e.pageX,y:e.pageY})
                };

                document.onmouseup = function (e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
                }
                dialogHeaderEl.onmousedown = moveDown;
            },
        }
    },
    data() {
        return {
            dialogVisible: this.visible,
            arrearAmt: 0, // 客户欠款
            prePayAmt: 0, // 客户预收款
            payPrepayAmt: 0, // 客户收款预收款
            returnPrepayAmt: 0, // 客户退货预收款
            totalAmt: this.dialogInfo.totalAmt, // 总金额
            queryForm: this.dialogInfo,
            payTypeList: [{ text: '混合(默认)', value: 'A' }, { text: '优先现款', value: 'B' }, { text: '优先预收款', value: 'C' }, { text: '优先欠款', value: 'D' }],
            dialogTable: [],
            dialogTableLoading: false,
            dialogTableReady: 0,
            customerPayType: ''
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val
            if (val) {
                // let payType = {}
                // if (this.power.payMethod) {
                //     let tempItem = this.payTypeList.filter(item => item.value == this.power.payMethod)
                //     payType = tempItem.length ? tempItem[0] : this.payTypeList[0]
                // } else {
                //     payType = this.payTypeList[0]
                // }
                // this.queryForm.payType = payType
                this.dialogTableReady = this.dialogTableReady + 1
            } else {
                this.dialogTableReady = 0
            }
        },
        dialogTableReady(val) {
            let tempNub = 0
            if (this.power.brandArrear == 'Y') {
                tempNub = 3
            } else if (this.power.brandArrear == 'N') {
                tempNub = 2
            }
            if (tempNub && val == tempNub) {
                this.payTypeChange(this.queryForm.payType)
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val)
        },
        // 'queryForm.arrearAmt'(val) {
        // if (this.power.brandArrear == 'N') return
        // let prev = val
        // this.dialogTable.some((item, index) => {
        //   if (prev > 0) {
        //     if (item.totalAmt < prev) {
        //       this.$set(this.dialogTable[index], 'arrearAmt', item.totalAmt)
        //       prev = prev - item.totalAmt
        //     } else {
        //       this.$set(this.dialogTable[index], 'arrearAmt', prev)
        //       return true
        //     }
        //   } else {
        //     this.$set(this.dialogTable[index], 'arrearAmt', 0)
        //   }
        // })
        // },
        'queryForm.payableAmt'(val) {
            this.queryForm.cashAmt = val
            this.queryForm.cardAmt = 0
        },
        'dialogInfo.totalAmt'(val) {
            this.totalAmt = val
        }
    },
    methods: {
        dialogClose() {
            this.queryForm.payType = {}
            this.queryForm.discountAmt = 0
            this.queryForm.prePayAmt = 0
            this.queryForm.arrearAmt = 0
            this.queryForm.cardAmt = 0
            this.queryForm.payableAmt = 0
            this.arrearAmt = 0
            this.prePayAmt = 0
            this.payPrepayAmt = 0
            this.returnPrepayAmt = 0
            this.dialogTable = []
        },
        // 获取焦点后选中内容
        focusAfterSelect(e) {
            e.currentTarget.select()
        },
        // 首字母大写
        titleCase(str) {
            return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        },
        payTypeChange(val) {
            if (this.power.isMoreCollection == 'N') {
                if (val.value.match(/A|B/i)) {
                    this.queryForm.account.selected = { text: '现金', value: '1001' }
                } else {
                    this.queryForm.account.selected = this.power.isDefaultCollectionMethod ? this.queryForm.account.list.filter(item => item.value == this.power.isDefaultCollectionMethod)[0] : {
                        text: '现金',
                        value: '1001'
                    }
                }
            } else {
                if (val.value.match(/A|B/i)) {
                    this.queryForm.account.selected = ''
                } else {
                    this.queryForm.account.selected = this.power.isDefaultCollectionMethod ? this.queryForm.account.list.filter(item => item.value == this.power.isDefaultCollectionMethod)[0] : ''
                }
            }
            if (val.value.match(/A|B/i)) {
                this.queryForm.discountAmt = 0
                this.queryForm.payableAmt = Number(this.totalAmt)
                this.queryForm.prePayAmt = 0
                this.queryForm.arrearAmt = 0
                this.queryForm.cardAmt = 0
                this.brandArrearDialogTableDispose(val.value)
            } else if (val.value == 'C') {
                this.queryForm.discountAmt = 0
                this.queryForm.arrearAmt = 0
                this.queryForm.cardAmt = 0
                if (this.prePayAmt < this.totalAmt) {
                    this.queryForm.payableAmt = Number(this.totalAmt) - Number(this.prePayAmt)
                    this.queryForm.prePayAmt = Number(this.prePayAmt)
                    this.brandArrearDialogTableDispose(val.value)
                    return
                }
                this.queryForm.payableAmt = 0
                this.queryForm.prePayAmt = Number(this.totalAmt)
                this.brandArrearDialogTableDispose(val.value)
            } else if (val.value == 'D') {
                this.queryForm.discountAmt = 0
                this.queryForm.payableAmt = 0
                this.queryForm.prePayAmt = 0
                this.queryForm.arrearAmt = Number(this.totalAmt)
                this.queryForm.cardAmt = 0
                this.brandArrearDialogTableDispose(val.value)
            }
        },
        // 分品牌欠款
        async getSalPayBalanceByCustomerID(customerID, tableData) {
            console.log(customerID, tableData)
            if (this.power.brandArrear == 'N') return
            this.dialogTableLoading = true
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectSalPayBalanceByCustomerID.html', this.Qs.stringify({ customerID: customerID, itemList: JSON.stringify(tableData) }))
            this.dialogTableLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            this.dialogTable = await JSON.parse(res.result.data)
            this.dialogTableReady = this.dialogTableReady + 1
        },
        // 获取门店余额
        async getSalPayBalanceAmt(customerID) {
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectSalPayBalanceAmt.html', this.Qs.stringify({ customerID: customerID }))
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            res.result.data = JSON.parse(res.result.data)
            this.arrearAmt = res.result.data.arrearAmt
            this.prePayAmt = res.result.data.prePayAmt
            this.payPrepayAmt = res.result.data.payPrepayAmt
            this.returnPrepayAmt = res.result.data.returnPrepayAmt
            this.dialogTableReady = this.dialogTableReady + 1
        },
        getCustomerPayMethod(customerID) {
            this.$post('/erpnew/account/c/reada46ceb/pubcustomer/selectCustomerPayMethodById.html', { customerCode: customerID }).then((res) => {
                console.log(res)
                if (res.data.code != '0') return this.$message.error(res.data.message)
                this.customerPayType = res.data.data
                if(this.customerPayType) {
                    let tempItemNew = this.payTypeList.filter(item => item.value == this.customerPayType)
                    if(tempItemNew.length) {
                        this.queryForm.payType = tempItemNew[0]
                    } else {
                        this.queryForm.payType = this.payTypeList[0]
                    }
                } else {
                    this.queryForm.payType = this.payTypeList[0]
                }
            })
        },
        brandArrearDialogTableDispose(val, tag) {
            if (this.power.brandArrear == 'N') return
            this.dialogTable.forEach((item) => {
                this.$set(item, 'arrearAmt', 0)
                this.$set(item, 'prepayAmt', 0)
            })
            if (val == 'C') {
                if (this.power.isPrePayDefaultSynthesis == 'Y') {
                    let brandItem = this.dialogTable[this.dialogTable.length - 1]
                    if (Number(this.queryForm.prePayAmt) < brandItem.oldPrePayAmt) {
                        brandItem.prepayAmt = Number(this.queryForm.prePayAmt)
                        return 0
                    } else {
                        brandItem.prepayAmt = brandItem.oldPrePayAmt
                        if (!tag) {
                            this.queryForm.prePayAmt = Number(brandItem.oldPrePayAmt)
                            this.queryForm.payableAmt = Number(this.totalAmt) - Number(brandItem.oldPrePayAmt)
                        }
                        return Number(this.queryForm.prePayAmt) - Number(brandItem.oldPrePayAmt)
                    }
                } else {
                    let prePayAmt = 0
                    let tempNub = this.dialogTable.reduce((prev, item) => {
                        let minNum = (item.oldPrePayAmt < item.totalAmt ? item.oldPrePayAmt : item.totalAmt)
                        let prepayAmt = (prev < minNum ? prev : minNum)
                        prePayAmt += prepayAmt
                        let surplus = Number(prev) - Number(prepayAmt)
                        this.$set(item, 'prepayAmt', Number(toFixedRe(prepayAmt, 2)))
                        return surplus
                    }, Number(this.queryForm.prePayAmt))
                    if (!tag) {
                        this.queryForm.payableAmt = Number(this.totalAmt) - prePayAmt
                        this.queryForm.prePayAmt = prePayAmt
                    }
                    return tempNub
                }
            }
            if (val == 'D') {
                if (this.power.isArrearDefaultSynthesis == 'Y') {
                    let brandItem = this.dialogTable[this.dialogTable.length - 1]
                    brandItem.arrearAmt = this.queryForm.arrearAmt
                } else {
                    this.dialogTable.reduce((prev, item) => {
                        console.log(prev)
                        let arrearAmt = (prev < Number(item.totalAmt) ? prev : Number(item.totalAmt))
                        let surplus = Number(prev) - Number(arrearAmt)
                        this.$set(item, 'arrearAmt', Number(toFixedRe(arrearAmt, 2)))
                        return surplus
                    }, this.queryForm.arrearAmt)
                }
            }
        },
        dialogTableInputNumberChange(val = 0, oldVal = 0, { column, row }) {
            this.$nextTick(() => {
                if (val <= 0) {
                    val = 0
                    this.$set(row, column.property, 0)
                }
                if (column.property == 'arrearAmt') {
                    if (row.financialBrandID != '2010010101010000000' && Number(val) + Number(row.prepayAmt) > Number(row.totalAmt)) {
                        val = Number(Number(row.totalAmt) - Number(toFixedRe(row.prepayAmt), 2))
                        this.$set(row, column.property, val)
                    }
                    // if (this.queryForm.arrearAmt > 0) {
                    //   this.$set(row, 'prepayAmt', row.prepayAmt - (val - oldVal))
                    //   this.queryForm.arrearAmt += (val - oldVal)
                    //   this.queryForm.prePayAmt -= (val - oldVal)
                    // } else {
                    this.$set(this.dialogTable[this.dialogTable.length - 1], 'arrearAmt', Number(toFixedRe(this.dialogTable[this.dialogTable.length - 1].arrearAmt + (oldVal - val)), 2))
                    // }
                } else {
                    this.$set(row, 'arrearAmt', Number(toFixedRe((row.arrearAmt - (val - oldVal)), 2)))
                    this.queryForm.arrearAmt = Number(toFixedRe((this.queryForm.arrearAmt - (val - oldVal)), 2))
                    this.queryForm.prePayAmt = Number(toFixedRe((this.queryForm.prePayAmt + (val - oldVal)), 2))
                }
            })
        },
        tableCellClick(row, { property }) {
            if (['arrearAmt', 'prepayAmt'].includes(property)) {
                this.$set(row, 'isShow' + this.titleCase(property), true)
            }
        },
        inputNumberChange(val, tag) {
            let tempItem = {
                discountAmt: '折扣金额',
                prePayAmt: '预收款金额',
                arrearAmt: '欠款金额',
                payableAmt: '实收金额'
            }
            this.$nextTick(() => {
                if (isNaN(val)) {
                    this.queryForm[tag] = 0
                }
                if (tag == 'prePayAmt') {
                    if (val > this.prePayAmt) {
                        this.$alert('预收款金额不能大于客户预收款余额', '提示')
                        this.queryForm.prePayAmt = this.prePayAmt
                        this.computeAmt(tag)
                        return
                    }
                }
                this.computeAmt(tag)
            })
        },
        computeAmt(tag) {
            let tempArr = ['discountAmt', 'prePayAmt', 'arrearAmt', 'payableAmt'].filter(item => item != tag)
            let payType = this.queryForm.payType.value
            if (tag == 'discountAmt') {
                this.queryForm.prePayAmt = this.queryForm.arrearAmt = this.queryForm.cardAmt = 0
                this.queryForm.payableAmt = Number((this.totalAmt - this.queryForm.discountAmt).toFixedRoundUp(2))
                this.brandArrearDialogTableDispose('A')
            } else if (tag == 'prePayAmt') {
                this.queryForm.arrearAmt = this.queryForm.cardAmt = 0
                this.queryForm.payableAmt = Number((this.totalAmt - this.queryForm.discountAmt - this.queryForm.prePayAmt).toFixedRoundUp(2))
            } else if (tag == 'payableAmt') {
                this.queryForm.cardAmt = 0
                if (['A', 'B', 'D'].includes(payType)) {
                    this.queryForm.prePayAmt = 0
                    let arrearAmt = Number((this.totalAmt - this.queryForm.discountAmt - this.queryForm.prePayAmt - this.queryForm.payableAmt).toFixedRoundUp(2))
                    if (arrearAmt < 0) {
                        this.$nextTick(() => {
                            this.queryForm.arrearAmt = 0
                            this.queryForm[tag] = this.totalAmt - (tempArr.reduce((prev, item, index) => {
                                console.log(prev)
                                return (index == 1 ? this.queryForm[prev] : prev) + this.queryForm[item]
                            }))
                        })
                        this.brandArrearDialogTableDispose('D')
                        return
                    }
                    this.queryForm.arrearAmt = arrearAmt
                    this.brandArrearDialogTableDispose('D')
                } else if (payType == 'C') {
                    this.queryForm.arrearAmt = 0
                    let prePayAmt = Number((this.totalAmt - this.queryForm.discountAmt - this.queryForm.arrearAmt - this.queryForm.payableAmt).toFixedRoundUp(2))
                    console.log(prePayAmt)
                    if (prePayAmt < 0) {
                        this.$nextTick(() => {
                            this.queryForm.prePayAmt = 0
                            this.queryForm[tag] = this.totalAmt - (tempArr.reduce((prev, item, index) => {
                                return (index == 1 ? this.queryForm[prev] : prev) + this.queryForm[item]
                            }))
                            this.brandArrearDialogTableDispose('C', 'computeAmt')
                        })
                        return
                    }
                    this.queryForm.prePayAmt = prePayAmt
                    let computeAmt = this.brandArrearDialogTableDispose('C', 'computeAmt')
                    console.log(computeAmt)
                    if (computeAmt) {
                        this.$nextTick(() => {
                            // let totalNub = this.dialogTable.reduce((prev, item) => {
                            //   return prev + Number(item.prepayAmt)
                            // }, 0)
                            // this.queryForm.payableAmt = Number(this.totalAmt) - totalNub
                            // this.queryForm.prePayAmt = totalNub
                            this.queryForm.prePayAmt = this.queryForm.prePayAmt - computeAmt
                            this.queryForm.arrearAmt = computeAmt
                            this.dialogTable.reduce((prev, item) => {
                                if (prev > 0) {
                                    let arrearAmt = (prev < (Number(item.totalAmt) - Number(item.prepayAmt)) ? prev : (Number(item.totalAmt) - Number(item.prepayAmt)))
                                    let surplus = Number(prev) - Number(arrearAmt)
                                    this.$set(item, 'arrearAmt', Number(toFixedRe(arrearAmt, 2)))
                                    return surplus
                                }
                            }, this.queryForm.arrearAmt)
                        })
                    }
                }
            } else if (tag == 'arrearAmt') {
                this.queryForm.cardAmt = 0
                this.queryForm.payableAmt = Number((this.totalAmt - this.queryForm.discountAmt - this.queryForm.prePayAmt - this.queryForm.arrearAmt).toFixedRoundUp(2))
            }
            if (tag.match(/discountAmt|prePayAmt|arrearAmt/i)) {
                let payableAmt = Number((this.totalAmt - this.queryForm.discountAmt - this.queryForm.prePayAmt - this.queryForm.arrearAmt).toFixedRoundUp(2))
                if (payableAmt < 0) {
                    this.$nextTick(() => {
                        this.queryForm.payableAmt = 0
                        this.queryForm[tag] = this.totalAmt - (tempArr.reduce((prev, item, index) => {
                            return (index == 1 ? this.queryForm[prev] : prev) + this.queryForm[item]
                        }))
                    })
                    return
                }
                this.queryForm.payableAmt = payableAmt
            }
        },
        rightInputNumberChange(val, tag) {
            if (tag == 'cashAmt') {
                this.queryForm.cardAmt = Number(this.queryForm.payableAmt - this.queryForm.cashAmt)
            } else {
                this.queryForm.cashAmt = Number(this.queryForm.payableAmt - this.queryForm.cardAmt)
            }
        },
        onSubmit(command = '') {
            let flag = true
            if (!this.queryForm.account.selected || !this.queryForm.account.selected.value) {
                if (this.power.isMoreCollection == 'Y') {
                    if (this.queryForm.cardAmt && this.queryForm.cardAmt > 0) {
                        flag = false
                    }
                } else {
                    flag = false
                }
            }
            if (!flag) return this.$confirm('支付方式不能为空', '提示', {
                showConfirmButton: false,
                type: 'warning'
            }).catch(err => err)
            let isHasNegative = this.dialogTable.some(item => item.arrearAmt < 0 || item.prepayAmt < 0)
            console.log(isHasNegative)
            if (isHasNegative) return this.$confirm('您的数据存在负数，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('submit', { queryForm: this.queryForm, dialogTable: this.dialogTable, command })
            }).catch(err => err)
            this.$emit('submit', { queryForm: this.queryForm, dialogTable: this.dialogTable, command })
        }
    }
}
</script>
<style scoped lang="less">
/* dialog */
/deep/.el-dialog {
    height: auto !important;
    min-width: 800px !important;

    .el-main {
        padding: 0 0 0 6px;
    }

    .dialog_box_card {
        height: 500px;
        overflow-y: auto;
        height: calc(100% - 2px);
    }

    .dialog_box_card .el-card__header {
        padding: 5px 20px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
    }

    .dialog_box_card .el-card__header>div:first-child {
        grid-column-start: span 2;
        text-align: center;
    }

    .dialog_box_card .el-card__body {
        padding: 0px;
    }

    .dialog_min_card .el-card__body {
        padding: 0px;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }

    .input_number {
        width: 140px;
    }

    .dialog_select .el-input__inner {
        padding: 0 0 0 6px;
    }

    .el-dialog__body {
        padding: 0 20px 30px;
    }

    .dialog_table .el-table td,
    .dialog_table .el-table th {
        padding: 0;
    }

    .text {
        color: #F56C6C;
        padding: 0 4px;
    }

    .el-autocomplete-suggestion {
        width: auto !important;
    }

    .el-cascader-node {
        padding: 0 20px 0 6px;
    }

    /*下拉框item选项的hover样式*/
    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        color: rgb(140, 197, 255);
        font-weight: 700;
    }

    /* 单元css */
    .mar_b_0 {
        margin-bottom: 0;
    }

    .mar_b_10 {
        margin-bottom: 10px;
    }

    .font_size_14 {
        font-size: 14px;
    }

    .prePay_from {
        position: relative;
    }

    .prePay_from .query_form_item:nth-child(2) {
        position: relative;
        flex: 1;
    }

    .prePay_from .prePay_from_item__label {
        position: absolute;
        z-index: 2;
        top: -12px;
        margin-left: 10px;
        padding: 0 6px;
        background-color: #fff;
        line-height: normal;
        font-family: "Helvetica Neue";
        font-size: 12px;
        color: #000;
    }

    .prePay_from .prePay_from_item__label {
        left: 48px;
    }

    .prePay_from .el-input-group__prepend {
        background-color: transparent;
    }

    .prePay_from .el-input-group__prepend .dialog_select {
        display: inline-block;
        margin: -10px -20px;
    }

    .prePay_from .el-input-group__prepend .dialog_select .el-select{
        margin: 0;
    }

    .prePay_from .el-input-group__prepend.disable {
        background-color: #F5F7FA;
    }
}
</style>